//@flow
import React, {useState, useEffect, useCallback} from 'react';
import {useToast, useToastActions} from '../utils';
import {makeStyles} from '@material-ui/core';
import TiendadaToast from '../../../elements/tiendada-toast';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: '1.5rem',
    left: '1.5rem',
    zIndex: 999999,
    width: '90%',
    maxWidth: '400px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: 'translateY(0) scale(1)',
    opacity: 1,
  },
  entering: {
    animation: '$slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  },
  exiting: {
    animation: '$slideOutDown 0.3s cubic-bezier(0.4, 0, 1, 1)',
  },
  '@keyframes slideInUp': {
    '0%': {
      transform: 'translateY(100%) scale(0.95)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateY(0) scale(1)',
      opacity: 1,
    },
  },
  '@keyframes slideOutDown': {
    '0%': {
      transform: 'translateY(0) scale(1)',
      opacity: 1,
    },
    '100%': {
      transform: 'translateY(100%) scale(0.95)',
      opacity: 0,
    },
  },
}));

export default function Toaster() {
  const classes = useStyles();
  const toast = useToast();
  const {closeToast} = useToastActions();

  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [currentToast, setCurrentToast] = useState(null);

  const handleClose = useCallback(() => {
    setIsExiting(true);

    setTimeout(() => {
      setIsVisible(false);
      setIsExiting(false);
      closeToast();
      currentToast?.onClose && currentToast.onClose();
      setCurrentToast(null);
    }, 300);
  }, [closeToast, currentToast]);

  useEffect(() => {
    if (toast) {
      setCurrentToast(toast);
      setIsVisible(true);
      setIsExiting(false);

      const timer = setTimeout(() => {
        handleClose();
      }, toast.duration || 5000);

      return () => clearTimeout(timer);
    }
  }, [toast, handleClose]);

  if (!isVisible || !currentToast) return null;

  const getAnimationClass = () => {
    if (isExiting) return classes.exiting;
    return classes.entering;
  };

  return (
    <div className={`${classes.root} ${getAnimationClass()}`}>
      <TiendadaToast
        title={currentToast.title}
        message={currentToast.message}
        type={currentToast.type}
        onClose={handleClose}
        action={currentToast.action}
      />
    </div>
  );
}
